import { createRouter, createWebHashHistory,createWebHistory } from 'vue-router';

import index from '@/views/index.vue';
import search_pic from '@/views/search_pic.vue';
import topic_pic from '@/views/topic_pic.vue';
import topic_pic_category from '@/views/topic_pic_category.vue';
import topic_pic_subcategory from '@/views/topic_pic_subcategory.vue';
import topic_video from '@/views/topic_video.vue';
import topic_video_detail from '@/views/topic/topic_video_detail.vue';
import topic_pic_detail from '@/views/topic/topic_pic_detail.vue';
import photo_grapher from '@/views/photo_grapher.vue';
import photo_grapher_album from '@/views/photo_grapher_album.vue';
import photo_grapher_detail from '@/views/photo_grapher_detail.vue';
import fvr from '@/views/vr/vr.vue';
import setting from '@/views/my/setting.vue';
import news from '@/views/news.vue';
import news_detail from '@/views/news_detail.vue';
import special_topics from '@/views/special_topics.vue';
import special_topics_category from '@/views/special_topics_category.vue';
// 订单
import order_list from '@/views/my/order/order_list.vue';
import order_pay from '@/views/my/order/order_pay.vue';
import order_detail from '@/views/my/order/order_detail.vue';
import pay_qrcode from '@/views/my/order/pay_qrcode.vue';
import cart from '@/views/my/cart.vue';
import wallet from '@/views/my/wallet.vue';
import auth_records from '@/views/my/auth_records.vue';

import favorites from '@/views/my/favorites.vue';
import home from '@/views/my/home.vue';
import content from '@/views/content.vue';
import article_list from '@/views/article.vue';
import article_detail from '@/views/article_detail.vue';
import price_package from '@/views/package.vue';
//生成订单合同
import contract from '@/views/my/contract.vue';

// 摄影师供稿
import no_settled from '@/views/my/grapher/no_settled.vue';
import application from '@/views/my/grapher/application.vue';
// 申请审核结果
import apply_pass from '@/views/my/grapher/apply_pass.vue';
import apply_nopass from '@/views/my/grapher/apply_nopass.vue';
import apply_passing from '@/views/my/grapher/apply_passing.vue';
// 供稿签约
import apply_contract from '@/views/my/grapher/apply_contract.vue';
import apply_info from '@/views/my/grapher/apply_info.vue';
import apply_work from '@/views/my/grapher/apply_work.vue';
import work_manage from '@/views/my/grapher/work_manage.vue';
import recharge from '@/views/my/grapher/recharge.vue';
// 图片视频征集
import active from '@/views/active.vue';
import active_detail from '@/views/active_detail.vue';
import active_list from '@/views/active_list.vue';
import active_collect_detail from '@/views/active_collect_detail.vue';
import active_collect_video_detail from '@/views/active_collect_video_detail.vue';

import subject_list from '@/views/subject_list.vue';
import subject_detail from '@/views/subject_detail.vue';

// 征集作品列表
import collect_work from '@/views/my/collect_work.vue';
// 合辑
import collect_folder from '@/views/my/collect_folder.vue';
import tale from '@/views/tale.vue';
import tale_detail from '@/views/tale_detail.vue';
import tale_video from '@/views/tale_video.vue';
import international from '@/views/international.vue';
import international_detail from '@/views/international_detail.vue';
import international_video from '@/views/international_video.vue';
import related_news_detail from '@/views/related_news_detail.vue';
import live from '@/views/live.vue';
import rtmp from '@/views/rtmp.vue';
import rtmp_new from '@/views/rtmp_new.vue';
import publish from '@/views/publish.vue';
import publish_detail from '@/views/publish_detail.vue';
import publish_video from '@/views/publish_video.vue';
import curated_article from '@/views/curated_article.vue';
import weekly_pick_list from '@/views/weekly_pick_list.vue';
import shanhai_qingdao_detail from '@/views/shanhai_qingdao_detail.vue';
import new_index from '@/views/new_index.vue';
import {
    buildNewsDetailUrl,
    buildPhotoDetailUrl,
    buildVideoDetailUrl,
    buildArticleDetailUrl,
    buildArticleListUrl,
    buildGalleryUrl,
    buildGalleryCategoryUrl,
    buildPhotosCategoryUrl,
    buildPhotosSubcategoryUrl,
    buildSubjectDetailUrl,
    buildStoryDetailUrl,
    buildStoryVideoUrl,
    buildReleaseDetailUrl,
    buildReleaseVideoUrl,
    buildIntlDetailUrl,
    buildIntlVideoUrl,
    buildPhotographerDetailUrl,
    buildPhotographersCategoryUrl,
    buildActivityNewsUrl,
    buildActiveDetailUrl,
    buildCollectPhotoUrl,
    buildCollectVideoUrl,
    buildActiveUrl,
} from '@/utils/seoUrl';

const legacyRedirects = [
    { path: '/news_detail', redirect: to => buildNewsDetailUrl(to.query.id) },
    { path: '/topic_pic_detail', redirect: to => buildPhotoDetailUrl(to.query.id) },
    { path: '/topic_video_detail', redirect: to => buildVideoDetailUrl(to.query.id) },
    { path: '/article_detail', redirect: to => buildArticleDetailUrl(to.query.id) },
    { path: '/article_list', redirect: to => buildArticleListUrl(to.query.id, to.query.type) },
    { path: '/special_topics', redirect: to => buildGalleryUrl(to.query.catid) },
    { path: '/special_topics_category', redirect: to => buildGalleryCategoryUrl(to.query.catid) },
    { path: '/topic_pic_category', redirect: to => buildPhotosCategoryUrl(to.query.catid) },
    { path: '/topic_pic_subcategory', redirect: to => buildPhotosSubcategoryUrl(to.query.catid) },
    { path: '/subject_detail', redirect: to => buildSubjectDetailUrl(to.query.id) },
    { path: '/tale_detail', redirect: to => buildStoryDetailUrl(to.query.id) },
    { path: '/tale_video', redirect: to => buildStoryVideoUrl(to.query.id) },
    { path: '/publish_detail', redirect: to => buildReleaseDetailUrl(to.query.id) },
    { path: '/publish_video', redirect: to => buildReleaseVideoUrl(to.query.id) },
    { path: '/international_detail', redirect: to => buildIntlDetailUrl(to.query.id) },
    { path: '/international_video', redirect: to => buildIntlVideoUrl(to.query.id) },
    { path: '/photo_grapher_detail', redirect: to => buildPhotographerDetailUrl(to.query.id) },
    { path: '/related_news_detail', redirect: to => buildActivityNewsUrl(to.query.id) },
    {
        path: '/active_detail',
        redirect: to => buildActiveDetailUrl(to.query.id || 0, to.query.type || 0, to.query.actid),
    },
    { path: '/active_collect_detail', redirect: to => buildCollectPhotoUrl(to.query.id) },
    { path: '/active_collect_video_detail', redirect: to => buildCollectVideoUrl(to.query.id) },
    {
        path: '/active',
        redirect: to => (to.query.id ? buildActiveUrl(to.query.id) : '/active_list'),
    },
];

const routes = [
    {
        path: '/',
        name: 'index',
        component: index,
        meta:{
            title: '首页',
            requiresAuth: false,
            keepAlive: true,
            description:"",
            keywords: "",

        },
    },
    {
        path: '/newIndex',
        name: 'new_index',
        component: new_index,
        meta: {
            title: 'Hi Qingdao',
            requiresAuth: false,
            keepAlive: false,
        },
    },
    {
        path: '/daily-scene',
        name: 'daily_scene',
        component: curated_article,
        meta: {
            title: '每日一景',
            curatedType: 'daily-scene',
            requiresAuth: false,
            keepAlive: false,
        },
    },
    {
        path: '/weekly-pick/list',
        name: 'weekly_pick_list',
        component: weekly_pick_list,
        meta: {
            title: '本周精选',
            requiresAuth: false,
            keepAlive: false,
        },
    },
    {
        path: '/weekly-pick/:id',
        name: 'weekly_pick_detail',
        component: curated_article,
        meta: {
            title: '本周精选',
            curatedType: 'weekly-pick',
            requiresAuth: false,
            keepAlive: false,
        },
    },
    {
        path: '/weekly-pick',
        name: 'weekly_pick',
        component: curated_article,
        meta: {
            title: '本周精选',
            curatedType: 'weekly-pick',
            requiresAuth: false,
            keepAlive: false,
        },
    },
    {
        path: '/shanhai-qingdao/:id',
        name: 'shanhai_qingdao_detail',
        component: shanhai_qingdao_detail,
        meta: {
            title: '山海名城 活力青岛',
            requiresAuth: false,
            keepAlive: false,
        },
    },
    {
        path: '/rtmp',
        name: 'rtmp',
        component: rtmp,
        meta:{
            title: '视频直播',
            requiresAuth: false,
            keepAlive: true
        },
    },
    {
        path: '/rtmp_new',
        name: 'rtmp_new',
        component: rtmp_new,
        meta:{
            title: '视频直播',
            requiresAuth: false,
            keepAlive: true
        },
    },
    {
        path: '/live',
        name: 'live',
        component: live,
        meta:{
            title: '视频直播',
            requiresAuth: false,
            keepAlive: true
        },
    },
    {
        path: '/activity-news/:id(\\d+)',
        name: 'related_news_detail',
        component: related_news_detail,
        meta:{
            title: '活动相关报道列表',
            requiresAuth: false,
            keepAlive: true
        },
    },
    {
        path: '/subject_list',
        name: 'subject_list',
        component: subject_list,
        meta:{
            title: '专题列表',
            requiresAuth: false,
            keepAlive: true
        },
    },
    {
        path: '/subject/:id(\\d+)',
        name: 'subject_detail',
        component: subject_detail,
        meta:{
            title: '专题详情',
            requiresAuth: false,
            keepAlive: true
        },
    },
    {
        path: '/my/collect_folder',
        name: 'collect_folder',
        component: collect_folder,
        meta:{
            title: '合辑列表',
            requiresAuth: true,
            keepAlive: true,
            allowCopy: true,
        },
    },
    {
        path: '/my/collect_work',
        name: 'collect_work',
        component: collect_work,
        meta:{
            title: '活动征集作品列表',
            requiresAuth: true,
            keepAlive: true,
            allowCopy: true,
        },
    },
    {
        path: '/collect/photo/:id(\\d+)',
        name: 'active_collect_detail',
        component: active_collect_detail,
        meta:{
            title: '活动征集作品图片详情',
            requiresAuth: false,
            keepAlive: true,
            allowCopy: true,
        },
    },
    {
        path: '/collect/video/:id(\\d+)',
        name: 'active_collect_video_detail',
        component: active_collect_video_detail,
        meta:{
            title: '活动征集作品视频详情',
            requiresAuth: false,
            keepAlive: true,
            allowCopy: true,
        },
    },
    {
        path: '/active_list',
        name: 'active_list',
        component: active_list,
        meta:{
            title: '活动列表',
            requiresAuth: false,
            keepAlive: true
        },
    },
    {
        path: '/activity/:id(\\d+)/:type(\\d+)/:actid(\\d+)',
        name: 'active_detail',
        component: active_detail,
        meta:{
            title: '内容表单',
            requiresAuth: true,
            keepAlive: true,
            allowCopy: true,
        },
    },
    {
        path: '/active/:actid(\\d+)',
        name: 'active',
        component: active,
        meta:{
            title: '活动征集',
            requiresAuth: false,
            keepAlive: true
        },
    },
    {
        path: '/tale',
        name: 'tale',
        component: tale,
        meta:{
            title: '青岛故事',
            requiresAuth: false,
            keepAlive: true
        },
    },
    {
        path: '/story/:id(\\d+)',
        name: 'tale_detail',
        component: tale_detail,
        meta:{
            title: '青岛故事详情',
            requiresAuth: false,
            keepAlive: true
        },
    },
    {
        path: '/story/video/:id(\\d+)',
        name: 'tale_video',
        component: tale_video,
        meta:{
            title: '青岛故事视频',
            requiresAuth: false,
            keepAlive: true
        },
    },
    {
        path: '/international',
        name: 'international',
        component: international,
        meta:{
            title: '国际传播',
            requiresAuth: false,
            keepAlive: true
        },
    },
    {
        path: '/intl/:id(\\d+)',
        name: 'international_detail',
        component: international_detail,
        meta:{
            title: '国际传播详情',
            requiresAuth: false,
            keepAlive: true
        },
    },
    {
        path: '/intl/video/:id(\\d+)',
        name: 'international_video',
        component: international_video,
        meta:{
            title: '国际传播视频',
            requiresAuth: false,
            keepAlive: true
        },
    },
    {
        path: '/publish',
        name: 'publish',
        component: publish,
        meta:{
            title: '青岛发布',
            requiresAuth: false,
            keepAlive: true
        },
    },
    {
        path: '/release/:id(\\d+)',
        name: 'publish_detail',
        component: publish_detail,
        meta:{
            title: '青岛发布详情',
            requiresAuth: false,
            keepAlive: true
        },
    },
    {
        path: '/release/video/:id(\\d+)',
        name: 'publish_video',
        component: publish_video,
        meta:{
            title: '青岛发布视频',
            requiresAuth: false,
            keepAlive: true
        },
    },
    {
        path: '/main',
        name: 'main',
        component: index,
        meta:{
            title: '主页',
            requiresAuth: false,
            keepAlive: true
        },
    },
    {
        path: '/price_package',
        name: 'price_package',
        component: price_package,
        meta:{
            title: '价格套餐',
            requiresAuth: false,
            keepAlive: true
        },
    },
    {
        path: '/content',
        name: 'content',
        component: content,
        meta:{
            title: '单页',
            requiresAuth: false,
            keepAlive: true
        },
    },
    {
        path: '/articles/:id(\\d+)/:type(\\d+)',
        name: 'article_list',
        component: article_list,
        meta:{
            title: '新闻列表',
            requiresAuth: false,
            keepAlive: true
        },
    },
    {
        path: '/article/:id(\\d+)',
        name: 'article_detail',
        component: article_detail,
        meta:{
            title: '新闻详情',
            requiresAuth: false,
            keepAlive: true
        },
    },
    {
        path: '/news',
        name: 'news',
        component: news,
        meta:{
            title: '视讯',
            requiresAuth: false,
            keepAlive: true
        },
    },
    {
        path: '/news/:id(\\d+)',
        name: 'news_detail',
        component: news_detail,
        meta:{
            title: '视讯详情',
            requiresAuth: false,
            keepAlive: true
        },
    },
    {
        path: '/search_pic',
        name: 'search_pic',
        component: search_pic,
        meta:{
            title: '以图搜图',
            requiresAuth: false,
            keepAlive: true
        },
    },
    {
        path: '/topic_pic',
        name: 'topic_pic',
        component: topic_pic,
        meta:{
            title: '图片专题',
            requiresAuth: false,
            keepAlive: true
        },
    },
    {
        path: '/gallery/:id(\\d+)',
        name: 'special_topics',
        component: special_topics,
        meta:{
            title: '图片专题',
            requiresAuth: false,
            keepAlive: true
        },
    },
    {
        path: '/gallery/category/:id(\\d+)',
        name: 'special_topics_category',
        component: special_topics_category,
        meta:{
            title: '图片专题分类',
            requiresAuth: false,
            keepAlive: true
        },
    },
    {
        path: '/photos/category/:id(\\d+)',
        name: 'topic_pic_category',
        component: topic_pic_category,
        meta:{
            title: '图片分类',
            requiresAuth: false,
            keepAlive: true
        },
    },
    {
        path: '/photos/subcategory/:id(\\d+)',
        name: 'topic_pic_subcategory',
        component: topic_pic_subcategory,
        meta:{
            title: '图片细分类',
            requiresAuth: false,
            keepAlive: true
        },
    },
    {
        path: '/photo/:id(\\d+)',
        name: 'topic_pic_detail',
        component: topic_pic_detail,
        meta:{
            title: '图片基本信息',
            requiresAuth: false,
            keepAlive: true
        },
    },
    {
        path: '/topic_video',
        name: 'topic_video',
        component: topic_video,
        meta:{
            title: '视频专题',
            requiresAuth: false,
            keepAlive: true
        },
    },
    {
        path: '/video/:id(\\d+)',
        name: 'topic_video_detail',
        component: topic_video_detail,
        meta:{
            title: '视频基本信息',
            requiresAuth: false,
            keepAlive: true
        },
    },

    {
        path: '/fvr',
        name: 'fvr',
        component: fvr,
        meta:{
            title: 'VR展览馆',
            requiresAuth: false,
            keepAlive: true
        },
    },
    {
        path: '/photo_grapher',
        name: 'photo_grapher',
        component: photo_grapher,
        beforeEnter: (to, _from, next) => {
            if (to.query.catid) {
                next({ path: buildPhotographersCategoryUrl(to.query.catid), replace: true });
            } else {
                next();
            }
        },
        meta:{
            title: '摄影师列表',
            requiresAuth: false,
            keepAlive: true
        },
    },
    {
        path: '/photographers/category/:id(\\d+)',
        name: 'photo_grapher_category',
        component: photo_grapher,
        meta:{
            title: '摄影师列表',
            requiresAuth: false,
            keepAlive: true
        },
    },
    {
        path: '/photo_grapher_album',
        name: 'photo_grapher_album',
        component: photo_grapher_album,
        meta:{
            title: '摄影师专辑',
            requiresAuth: false,
            keepAlive: true
        },
    },
    {
        path: '/photographer/:id(\\d+)',
        name: 'photo_grapher_detail',
        component: photo_grapher_detail,
        meta:{
            title: '摄影师作品',
            requiresAuth: false,
            keepAlive: true
        },
    },
    {
        path: '/my/home',
        name: 'home',
        component: home,
        meta:{
            title: '个人中心首页',
            requiresAuth: true,
            keepAlive: true,
            allowCopy: true,
        },
    },
    {
        path: '/my/recharge',
        name: 'recharge',
        component: recharge,
        meta:{
            title: '收益中心',
            requiresAuth: true,
            keepAlive: true,
            allowCopy: true,
        },
    },
    {
        path: '/my/work_manage',
        name: 'work_manage',
        component: work_manage,
        meta:{
            title: '作品管理',
            requiresAuth: true,
            keepAlive: true,
            allowCopy: true,
        },
    },
    //摄影师供稿
    {
        path: '/my/apply_work',
        name: 'apply_work',
        component: apply_work,
        meta:{
            title: '摄影师供稿',
            requiresAuth: true,
            keepAlive: true,
            allowCopy: true,
        },
    },
    // 入住信息
    {
        path: '/my/apply_info',
        name: 'apply_info',
        component: apply_info,
        meta:{
            title: '入驻信息',
            requiresAuth: true,
            keepAlive: true,
            allowCopy: true,
        },
    },
    // 供稿合同签约
    {
        path: '/my/apply_contract',
        name: 'apply_contract',
        component: apply_contract,
        meta:{
            title: '供稿合同签约',
            requiresAuth: true,
            keepAlive: true,
            allowCopy: true,
        },
    },
    {
        path: '/my/application',
        name: 'application',
        component: application,
        meta:{
            title: '入驻申请',
            requiresAuth: true,
            keepAlive: true,
            allowCopy: true,
        },
    },
    {
        path: '/my/apply_pass',
        name: 'apply_pass',
        component: apply_pass,
        meta:{
            title: '入驻申请通过',
            requiresAuth: true,
            keepAlive: true
        },
    },
    {
        path: '/my/apply_nopass',
        name: 'apply_nopass',
        component: apply_nopass,
        meta:{
            title: '入驻申请未通过',
            requiresAuth: true,
            keepAlive: true
        },
    },
    {
        path: '/my/no_settled',
        name: 'no_settled',
        component: no_settled,
        meta:{
            title: '未入驻提示页',
            requiresAuth: true,
            keepAlive: true
        },
    },
    {
        path: '/my/apply_passing',
        name: 'apply_passing',
        component: apply_passing,
        meta:{
            title: '申请审核中',
            requiresAuth: true,
            keepAlive: true
        },
    },
    {
        path: '/my/contract',
        name: 'contract',
        component: contract,
        meta:{
            title: '图片购买合同',
            requiresAuth: true,
            keepAlive: true,
            allowCopy: true,
        },
    },
    {
        path: '/my/setting',
        name: 'setting',
        component: setting,
        meta:{
            title: '账号设置',
            requiresAuth: true,
            keepAlive: true,
            allowCopy: true,
        },
    },
    {
        path: '/my/cart',
        name: 'cart',
        component: cart,
        meta:{
            title: '购物车',
            requiresAuth: true,
            keepAlive: true
        },
    },
    {
        path: '/my/wallet',
        name: 'wallet',
        component: wallet,
        meta:{
            title: '我的钱包',
            requiresAuth: true,
            keepAlive: true
        },
    },
    {
        path: '/my/auth_records',
        name: 'auth_records',
        component: auth_records,
        meta:{
            title: '授权记录',
            requiresAuth: true,
            keepAlive: true
        },
    },
    {
        path: '/my/favorites',
        name: 'favorites',
        component: favorites,
        meta:{
            title: '我的收藏',
            requiresAuth: true,
            keepAlive: true
        },
    },
    {
        path: '/my/order_list',
        name: 'order_list',
        component: order_list,
        meta:{
            title: '订单列表',
            requiresAuth: true,
            keepAlive: true
        },
    },
    {
        path: '/my/order_detail',
        name: 'order_detail',
        component: order_detail,
        meta:{
            title: '订单详情',
            requiresAuth: true,
            keepAlive: true
        },
    },
    {
        path: '/my/order_pay',
        name: 'order_pay',
        component: order_pay,
        meta:{
            title: '订单支付确认页',
            requiresAuth: true,
            keepAlive: true
        },
    },
    {
        path: '/my/pay_qrcode',
        name: 'pay_qrcode',
        component: pay_qrcode,
        meta:{
            title: '订单支付页',
            requiresAuth: true,
            keepAlive: true
        },
    },
    // { 
    //     path: '/:pathMatch(.*)*', 
    //     name: 'NotFound', 
    //     component: NotFound 
    // },
    ...legacyRedirects,
];

const router = createRouter({
    history: createWebHistory(), //createWebHashHistory(),//
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { top: 0 };
        }
    },


});

export default router;
